import { render, staticRenderFns } from "./TongzhiDetail.vue?vue&type=template&id=216bb14c&scoped=true"
import script from "./TongzhiDetail.vue?vue&type=script&lang=js"
export * from "./TongzhiDetail.vue?vue&type=script&lang=js"
import style0 from "./TongzhiDetail.vue?vue&type=style&index=0&id=216bb14c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216bb14c",
  null
  
)

export default component.exports